import { object, string } from 'yup';

export const BREAKDOWN_DEBOUNCE_MS = 400;
export const PERCENTAGE = 100;

export const paymentSchema = object().shape({
  paymentDate: string().nullable().required('Payment date is required'),
  effectiveDate: string().nullable().required('Effective date is required'),
  dueDate: string().nullable().required('Due date is required'),
  totalAmount: string().required('Total amount is required'),
  paymentMethod: object().nullable().required('Payment method is required'),
  paymentStatus: object().nullable().required('Payment status is required'),
});

export const OBSERVABLE_FIELDS = [
  'paymentDate',
  'effectiveDate',
  'dueDate',
  'totalAmount',
  'principalAmount',
  'interestAmount',
  'escrowAmount',
  'lateFeeAmount',
  'otherAmount',
  'suspenseAmount',
  'paymentMethod',
  'paymentStatus',
  'referenceNumber',
  'notes',
];
